import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import { Text } from '../../components/Text';

export const ErrorBoundary: React.FC = () => {
  let error = useRouteError();

  useEffect(() => {
    console.warn('Error Boundary:', error);
  }, [error]);

  return (
    <div>
      <Text
        as="h1"
        fontSize="xl"
        fontWeight="bold"
        color="danger"
        align="center"
      >
        Something went wrong, please refresh this page or contact our support
      </Text>
    </div>
  );
};
